/**
 * Checks if a URL is valid http/https URL
 * @param url
 */
export const isValidHttpUrl = (url) => {
    try {
        const newUrl = new URL(url);
        return newUrl.protocol === 'http:' || newUrl.protocol === 'https:';
    }
    catch (err) {
        return false;
    }
};
export const isJSON = (text) => {
    try {
        const sanitizedText = escapeJSONControlChars(text);
        JSON.parse(sanitizedText);
        return true;
    }
    catch (err) {
        return false;
    }
};
export const isPrimitve = (value) => ['string', 'boolean', 'number', 'symbol', 'bigint'].includes(typeof value) || value === null || value === undefined;
export const isObject = (value) => !isPrimitve(value) && !Array.isArray(value) && typeof value === 'object';
export const flattenObjectWithDotNotation = (source, target = {}, prefix = '') => {
    target = target || {};
    prefix = prefix || '';
    if (source && isObject(source)) {
        Object.keys(source).forEach(key => {
            if (typeof (source[key]) === 'object') {
                if (Array.isArray(source[key])) {
                    target[prefix + key] = JSON.stringify(source[key]);
                }
                flattenObjectWithDotNotation(source[key], target, prefix + key + '.');
            }
            else {
                return target[prefix + key] = source[key];
            }
        });
    }
    return target;
};
export const getDistinctArray = (arr) => {
    const set = new Set(arr);
    return [...set];
};
const isValidBase64 = (str) => {
    if (typeof str !== 'string' || str.length % 4 !== 0) {
        return false;
    }
    // Base64 regex pattern
    const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;
    if (!base64Regex.test(str)) {
        return false;
    }
    try {
        Buffer.from(str, 'base64').toString('utf8');
        return true;
    }
    catch (err) {
        return false;
    }
};
export const escapeJSONControlChars = (jsonString) => {
    return jsonString.replace(/"(?:\\.|[^"\\])*"/g, (strLiteral) => {
        // Extract the string content without quotes
        const stringContent = strLiteral.slice(1, -1);
        // Bypass early for base64 strings as they can be quite large leading to call stack exceeded error with the one by one character replacement and a valid base64 string would not have any control characters
        if (isValidBase64(stringContent)) {
            return strLiteral;
        }
        // eslint-disable-next-line
        return strLiteral.replace(/[\u0000-\u001F]/g, (char) => {
            switch (char) {
                case '\b': return '\\b';
                case '\f': return '\\f';
                case '\n': return '\\n';
                case '\r': return '\\r';
                case '\t': return '\\t';
                default:
                    // Use unicodes \u00XX escape for other control characters
                    return `\\u${char.charCodeAt(0).toString(16).padStart(4, '0')}`;
            }
        });
    });
};
export const isPlatformArray = (rawArrayValue) => rawArrayValue && rawArrayValue.startsWith('{') && rawArrayValue.endsWith('}');
export const parsePlatformArray = (rawArrayValue) => {
    let parsedValue = [];
    if (rawArrayValue.charAt(0) !== '[' && rawArrayValue.charAt(rawArrayValue.length - 1) !== ']') {
        if (isPlatformArray(rawArrayValue)) {
            rawArrayValue = `[${rawArrayValue.substring(1, rawArrayValue.length - 1)}]`;
        }
        else if (typeof rawArrayValue === 'string') {
            // value is primitive, convert to array
            rawArrayValue = rawArrayValue.startsWith('"') && rawArrayValue.endsWith('"') ? `[${rawArrayValue}]` : `["${rawArrayValue}"]`;
        }
    }
    try {
        const sanitizedValue = escapeJSONControlChars(rawArrayValue);
        parsedValue = JSON.parse(sanitizedValue);
    }
    catch (err) {
        const parsingError = new Error(`Failed to parse platform array, raw value: ${rawArrayValue}`, {
            cause: err
        });
        console.error(parsingError);
        throw parsingError;
    }
    return parsedValue;
};
export const stringifyPlatformArray = (array) => {
    let strigifiedArray = '';
    strigifiedArray = JSON.stringify(array);
    strigifiedArray = `{${strigifiedArray.substring(1, strigifiedArray.length - 1)}}`;
    return strigifiedArray;
};
export const isArrayOfPrimitives = (array) => !array.some(item => !isPrimitve(item));
